// Config.js
function pickEnv(key, fallback) {
  const v = (process.env && process.env[key] ? String(process.env[key]) : "").trim();
  if (!v || v === '""' || v === "''") return fallback;
  return v;
}

const Config = {
  // Login único
  get authBaseUrl() {
    return pickEnv("REACT_APP_AUTH_BASE_URL", "https://localhost/api");
  },
  // Base por Unidad (runtime)
  get baseUrl() {
    const unit = localStorage.getItem("businessUnit") || "PBCH";
    const map = {
      PBCH: pickEnv("REACT_APP_API_BASE_URL_PBCH", "https://localhost/api"),
      PEBEBRO: pickEnv("REACT_APP_API_BASE_URL_PEBEBRO", "https://localhost/api"),
    };
    return map[unit] || map.PBCH;
  }
};

export default Config;
